export default {
  title: {
    en: 'Tracker',
  },
  empty: {
    title: {
      en: 'No statistics for this event',
    },
  },
  warning: {
    en: 'Statistics are automatically changed for the selected match.',
  },
}
